import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#fff",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "clip-path": "url(#i-1244710122__a)"
    }, [
      _createElementVNode("path", { d: "M7.5 15.75H3a.75.75 0 0 1-.75-.75V9A.75.75 0 0 1 3 8.25h4.5L14.25 3v18zM7.5 8.25v7.5M18 10.017a3 3 0 0 1 0 3.966M20.782 7.5a6.75 6.75 0 0 1 0 9" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1244710122__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }